import { render, staticRenderFns } from "./ManualNotifications.vue?vue&type=template&id=719999ba&"
import script from "./ManualNotifications.vue?vue&type=script&lang=js&"
export * from "./ManualNotifications.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports